import { defineStore } from "pinia";
import axios from "@/api/axios";
import type {
  Report,
  CreateReportResponse,
  CreateReportRequest
} from "@/types/reports";
import createFileDownloadLink from "@/composables/createFileDownloadLink";
import { useStore } from "@/stores/index";

export const useReportStore = defineStore("ReportStore", {
  state: () => ({
    currentReport: null as Report | null,
  }),

  getters: {
    getCurrentReport: (state) => state.currentReport,
  },

  actions: {
    /**
     * POST /api/files/reports
     * Создать сводный отчет
     */
    async createReport(year: number): Promise<CreateReportResponse> {
      const store = useStore();

      try {
        const requestBody: CreateReportRequest = { year };

        const response = await axios.post<CreateReportResponse>(
          "/oracul/api/files/reports",
          requestBody
        );

        console.log("Create report response:", response);
        this.currentReport = response.data;
        store.showSuccess("Отчет создан успешно", `Сводный отчет за ${year} год`);
        return response.data;
      } catch (error) {
        store.showError("Ошибка создания отчета", "Не удалось создать сводный отчет");
        throw error;
      }
    },

    /**
     * GET /api/files/reports/{year}/export
     * Экспорт сводного отчета в Excel
     */
    async exportReport(year: number): Promise<void> {
      const response = await axios.get(
        `/oracul/api/files/reports/${year}/export`,
        { responseType: "blob" }
      );

      createFileDownloadLink(response, `report_${year}.xlsx`);
    },

    /**
     * GET /api/files/reports/{year}
     * Получить сводный отчет
     */
    async getReport(year: number): Promise<Report> {
      const store = useStore();

      try {
        const response = await axios.get<Report>(
          `/oracul/api/files/reports/${year}`
        );

        console.log("Get report response:", response);
        this.currentReport = response.data;
        return response.data;
      } catch (error) {
        store.showError("Ошибка загрузки отчета", `Не удалось загрузить отчет за ${year} год`);
        throw error;
      }
    },

    /**
     * POST /api/files/reports/{id}/approve
     * Подтвердить отчет по идентификатору
     */
    async approveReport(id: string): Promise<void> {
      await axios.post<void>(
        `/oracul/api/files/reports/${id}/approve`
      );

      console.log("Report approved:", id);
    },
  },
});
